export const globalScrollbarStyles = {
  "*": {
    scrollbarWidth: "thin",
    scrollbarColor: "var(--chakra-colors-gray-300) transparent",
  },
};
